import React from "react";

import Button from "./Button";
import ButtonLayouts from "./ButtonLayouts";

import "./styles/style.scss";

export default Button;

export const ButtonLayout = (props) => (
  <ButtonLayouts type="layout" {...props} />
);
ButtonLayout.displayName = "ButtonLayout";

export const ButtonGroup = (props) => <ButtonLayouts type="group" {...props} />;
ButtonGroup.displayName = "ButtonGroup";

export const ButtonPrimary = (props) => <Button type="primary" {...props} />;
ButtonPrimary.displayName = "ButtonPrimary";

export const ButtonSecondary = (props) => (
  <Button type="secondary" {...props} />
);
ButtonSecondary.displayName = "ButtonSecondary";

export const ButtonLink = (props) => <Button type="link" {...props} />;
ButtonLink.displayName = "ButtonLink";

export const ButtonHollow = (props) => <Button type="hollow" {...props} />;
ButtonHollow.displayName = "ButtonHollow";
